
export class Permission {
    id: number;
    name: string;
    permissions: any[];

    constructor() {
    }

}
